import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../components/common/forms/FormPayment";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import {
  non_public_lmt_registration,
  non_profit_shareholder,
  non_profit_details_of_shareholder,
} from "./NonProfitCompanyRegArr";
import Images from "../../../../media/images";
import { v4 as uuidv4 } from "uuid";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import BackButton from "../../../../components/common/backbutton/BackButton";
import api from "../../../../api/api";
import { toast, ToastContainer } from "react-toastify";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import NonProfitCompnyFee from "./NonProfitFeeModal";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

const NonProfitCompanyRegistration = () => {
  const { register, handleSubmit } = useForm();
  const [shareHolders, setShareHolders] = useState([
    {
      ...non_profit_shareholder,
      id: uuidv4(),
    },
  ]);

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)

  const [paymentRangeList, setPaymentList] = useState([])


 
  const [uploadProof, setUploadProof] = useState("");
  const [amount, setAmount] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [dueAmount, setDueAmount] = useState(null)
  const [paidAmount, setPaidAmount] = useState(null)



  // for filtering by company_type and show in Modal
  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=non_profit')
    .then(response=> {
        console.log('response.data',response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
    })
  }, [])


  // For amount calculation
  useEffect(() => {
    if(amount > 0){
      let arr = paymentRangeList.filter((item) => { 
        return amount >= parseInt(item.range_start) && amount <= parseInt(item.range_end)
      })
      console.log(arr)

      arr.length > 0  && setTotalAmount(arr[0]?.amount)
    }else{
      setTotalAmount(0)
    }
  }, [amount, paymentRangeList])



   // getting current user
   useEffect(()=> {
    api.get("/users/me/")
    .then(response=> {
        setDueAmount(response.due_amount)
    }).catch(error=> {

    }) 
  },[])




  // console.log(non_public_lmt_registration);
  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.company_type = "non_profit";
    data.documents = [];

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: 2500,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Data Registration Failed");
      });
  };
  return (
    <form className="px-10 lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
        Non Profit Company Registration Form
      </p>
      <div className="mt-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>
      <p className="text-primary-blue text-lg underline">
        1. Company Name Details
      </p>

      <ComapanyNameDetails register={register} />
      {/* <FormOtherDetails /> */}
      <p className="text-primary-blue my-2 text-lg underline">2. Other Details</p>
      <div className="flex items-center gap-5 md:flex-row flex-col ">
        <div className="relative border-primary-blue max-w-3xl md:w-[60rem] border-2 md:border-b-1 font-bold">
          <div>
            {non_public_lmt_registration.map((item, i) => {
              const { name, validation, ip1, type } = item;
              // console.log(item);
              return (
                <div
                  key={i}
                  className="border-primary-blue flex flex-col border-b md:flex-row"
                >
                  <p className="text-primary-red font-Laila px-5 py-2 sm:!w-[380px]">
                    {ip1}
                  </p>
                  <input
                    type={type}
                    name={name}
                    
                    {...register(name,  
                      {onChange: (e) => {e.target.name === "total_share_holders" && setAmount(e.target.value)} })}
                      
                      
                    className="border-primary-blue w-full border-t md:border-t-0  py-2 pl-3 outline-none md:border-l-2 lg:border-l-2"
                  />
                </div>
              );
            })}
          </div>
          <div className="md:absolute hidden md:block border bottom-0 text-primary-blue border-primary-blue right-0  w-[28%] z-40 bg-red-200 ">
            <div className="text-center font-Laila">
              सदस्य संख्याको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
              <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
            </div>{" "}
          </div>
        </div>
        <div>
          <div>
            <div className="border-primary-red text-primary-blue w-fit text-center text-sm font-Laila rounded-full border-2 p-2 md:text-base">
              Non Profit Company दर्ता शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि
              यहाँ  <span
                data-bs-toggle="modal"
                data-bs-target="#exampleModalEdit"
                className="text-primary-red cursor-pointer"
              >
                Click
              </span> गर्नुहोस |
              <NonProfitCompnyFee paymentRangeList={paymentRangeList} />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-5">
        <div className="flex flex-wrap justify-between"> */}
      <span className="text-primary-blue mt-5  text-lg underline">
        3. Details of Members <span className="text-primary-blue font-Laila underline">
          (शेयर सदस्य तथा साँक्षीहरुको विवरण) (प्रा.लि. कम्पनीमा बढिमा १०१ जना
          सम्म सदस्य रहन सकिन्छ ।)
        </span>
      </span>

      {/* test */}
      {/* <img
                onClick={() => {
                  setTableRow(tableRow + 1)
                  // setShareHolders([{name:'', address: ''}])
                  setShareHolders(shareHolders => [...shareHolders, { name: "", address: "", share_amount: "", citizenship: "", witness_name: "", witness_address: "", witness_citizenship: "" }])


                  console.log(shareHolders)
                }

                }
                src={Images.row_add}
                className="h-10 w-10 cursor-pointer"
                alt=""
                srcSet=""
              />
              {/* test close */}
      {/* </div>
      </div>  */}

      {/* <DetailsOfShareHolders /> */}
      <DetailsOfShareHolders
        DetailShareholder={non_profit_details_of_shareholder}
        needed_share={non_profit_shareholder}
        setShareHolders={setShareHolders}
        shareHolders={shareHolders}
      />
      <p className="text-primary-blue text-lg my-3 underline">
        4. Main Objectives <span className="text-primary-blue font-Laila underline">
          (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
        </span>
      </p>

      <MainObjectives register={register} />
      <p className="text-primary-blue text-lg my-3 underline">
        5. Working Branch <span className="text-primary-blue font-Laila underline">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </p>
      <FormBranch register={register} />
      <div></div>
      <FormButtom />
      <FormPayment
        handleSubmit={handleSubmit}
        handleClick={handleClick}
        setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default NonProfitCompanyRegistration;
